import { SingleOption } from '@frontend/components/basic-forms';
import { EquipmentEnumClient } from '@frontend/equipment/api';
import { EquipmentState, EquipmentStateName } from '@frontend/equipment/types';
import { useEffect, useState } from 'react';

import { EquipmentStateSelectV2Props } from './equipment-state-select-v2.component';

interface ViewProps {
    options: SingleOption<EquipmentStateName>[];
}

const useEquipmentStateSelectV2 = (props: EquipmentStateSelectV2Props): ViewProps => {
    const [options, changeOptions] = useState<SingleOption<EquipmentStateName>[]>([]);

    useEffect(() => {
        EquipmentEnumClient.fetchEquipmentStates().then((states) => {
            const stateOptions = states
                .filter((state) => state !== EquipmentStateName.EQUIPMENT_ANY_STATE)
                .filter((state) => state !== EquipmentStateName.EQUIPMENT_CREATED)
                .filter((state) => (props.subset ? props.subset.includes(state) : true))
                .map((state) => {
                    const found = EquipmentState.ALL.find((t) => t.value === state);
                    if (found) {
                        return {
                            value: found.value,
                            label: found.value,
                            display: found.displayName
                        };
                    } else
                        return {
                            value: state,
                            label: state.replace(/_/g, ' ')
                        };
                });

            return changeOptions([
                ...(props.includeAnyState
                    ? [
                          {
                              value: EquipmentStateName.EQUIPMENT_ANY_STATE,
                              label: props.anyStateLabel ?? EquipmentStateName.EQUIPMENT_ANY_STATE,
                              display: props.anyStateDisplay ?? EquipmentState.EQUIPMENT_ANY_STATE.displayName
                          }
                      ]
                    : []),
                ...stateOptions
            ]);
        });
    }, [props.subset, props.includeAnyState, props.anyStateLabel, props.anyStateDisplay]);

    return { options };
};

export default useEquipmentStateSelectV2;
